
import { createSlice } from "@reduxjs/toolkit";

const initialState = { user: null }

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        createUser: (state, action) => {
            return { ... state,
                user: {
                    id: action.payload.id,
                    empresa: action.payload.empresa,
                    nome: action.payload.nome,
                    email: action.payload.email,
                }
            }
        },
        updateUser: (state, action) => {
            return { ... state,
                user: {
                    id: action.payload.id,
                    empresa: action.payload.empresa,
                    nome: action.payload.nome,
                    email: action.payload.email,
                }
            }
        },
        logoutUser: (state) => {
            return { ... state,
                user: null,
            }
        }
    }

})


export const { createUser, updateUser, logoutUser } = userSlice.actions;
export default userSlice.reducer;

